<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7HiZ2l/tc-custom/9781504075473.jpg?1726574076946" alt="This image is the cover for the book Pink Umbrella, The Pat and Jean Abbott Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pink Umbrella, The Pat and Jean Abbott Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>As World War II rages, a newlywed PI must engage in some detection before his deployment . . .</b><br/><br/>Pat Abbott has put aside his work as a private detective to serve his country as a marine in World War II—though more presently, he’s sneaking in a quick New York honeymoon with his beloved brand-new wife, Jean. But because of the war, many of his old acquaintances are reluctantly returning from Paris—and one of them is now suspected of murder.<br/><br/>Neither Pat nor Jean is overly fond of the expatriate crowd in general—and Jean has a particular dislike for a divorcée whom Pat seems to admire—but Pat believes the accused is a decent sort, and intends to do his part in finding the real culprit . . .<br/><br/><b>Praise for the</b><b>Pat and Jean Abbott Mysteries</b><br/><br/>“Amusing and sophisticated.” —<i>The Star </i>(London)<br/><br/>“[A] well-plotted and mystifying case.” —<i>Saturday Review</i><br/><br/>“One of the more interesting married teams of detectives . . . A sort of globetrotting Nick and Nora.” —<i>Thrilling Detective</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Frances Crane
      </h2>
      
      <p class="authorDescription body article">Frances Crane (1890&ndash;1981) was an American author and former writer for the<I> New Yorker</I>. She was invited to leave Nazi Germany in the late 1930s after writing a number of unfavorable articles about Hitler. After settling in Taos, New Mexico, Crane introduced private investigator Pat Abbott and his future wife Jean in her first novel, <I>The Turquoise Shop</I> (1941). The Abbotts investigated crimes in a total of twenty-six volumes, each with a color in the title, with settings around the country and globe.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      BANTAM Books, LONDON
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?30a98b24